import { render } from "./end.vue?vue&type=template&id=444af087&scoped=true"
import script from "./end.vue?vue&type=script&lang=js"
export * from "./end.vue?vue&type=script&lang=js"

import "./end.vue?vue&type=style&index=0&id=444af087&scoped=true&lang=less"

import exportComponent from "D:\\Septris Remake\\septris-remake\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-444af087"]])

export default __exports__